import { getObjectSchema } from '../Hasp/properties/v2/wireFormat.js'
import {
    HA_ACTION_DATA_SUGGESTIONS,
    OBJECT_BACKGROUND_COLOR_REFERENCE,
} from '../Hasp/properties/v2/shared.js'
import { objectBackgroundColorToRgb } from '../automation/objectBackgroundColor.js'
import { DesignerSchemaAdapter } from '../components/hassbuilder/metadata/DesignerSchemaAdapter.js'

/**
 * Return schema-v2 HA action-data suggestions for one provider/service pair.
 *
 * `objTypeOrSchema` is optional for non-widget callers such as the media
 * player editor. EntityBuilder callers pass the selected object's schema so
 * widget-specific ordering and any schema override are respected.
 */
export function getServiceDataSuggestions(service, action, objTypeOrSchema = null, object = null, eventName = '') {
    const schema = typeof objTypeOrSchema === 'string'
        ? getObjectSchema(objTypeOrSchema)
        : objTypeOrSchema
    const automation = schema?.automation
    const adapter = schema ? new DesignerSchemaAdapter(schema) : null
    const catalogue = eventName
        ? (adapter?.getActionHints(eventName, { object })
            ?? automation?.actionHints
            ?? automation?.dataSuggestions
            ?? HA_ACTION_DATA_SUGGESTIONS)
        : (automation?.dataSuggestions
            ?? automation?.actionHints
            ?? HA_ACTION_DATA_SUGGESTIONS)
    const all = catalogue[service]?.[action] ?? []
    const preferred = automation?.preferredDataParameters?.[`${service}.${action}`] ?? []
    const promotedIndexes = new Set(
        preferred.map(parameter => all.findIndex(suggestion => suggestion.parameter === parameter)),
    )
    const ordered = preferred.length === 0
        ? all
        : [
            ...preferred.map(parameter => all.find(suggestion => suggestion.parameter === parameter)).filter(Boolean),
            // Keep alternative suggestions for a preferred parameter as well
            // (for example cpicker's current RGB payload and its optional
            // object.bg_color fallback). Only the first matching suggestion is
            // promoted; the remaining entries must stay selectable.
            ...all.filter((suggestion, index) => !promotedIndexes.has(index)),
        ]

    return ordered.filter(suggestion => (
        suggestion.value !== OBJECT_BACKGROUND_COLOR_REFERENCE
        || !!objectBackgroundColorToRgb(object)
    ))
}
